"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textToTokenConverter = void 0;
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var Variables_1 = require("ContentTokens/DataModels/Variables");
var Common_1 = require("ContentTokens/Models/Common");
var textToTokenConverter = function (text, options) {
    if (options === void 0) { options = { fromClipboard: false, tokenType: Common_1.BlockType.Paragraph }; }
    if (options.fromClipboard) {
        var deserialisedResult = (0, Variables_1.deserialiseVariableFromText)(text);
        if (deserialisedResult.isValid) {
            return deserialisedResult.tokens;
        }
    }
    return plainTextToTokenConverter(text, options.tokenType);
};
exports.textToTokenConverter = textToTokenConverter;
var plainTextToTokenConverter = function (text, tokenType) {
    var e_1, _a;
    if (tokenType === void 0) { tokenType = Common_1.BlockType.Paragraph; }
    var tokens = [];
    var linesOfText = text.split("\n");
    try {
        for (var linesOfText_1 = __values(linesOfText), linesOfText_1_1 = linesOfText_1.next(); !linesOfText_1_1.done; linesOfText_1_1 = linesOfText_1.next()) {
            var line = linesOfText_1_1.value;
            tokens.push(TokenModels_1.default[tokenType].createToken());
            tokens.push(TokenModels_1.default.text.createToken(line, {}));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (linesOfText_1_1 && !linesOfText_1_1.done && (_a = linesOfText_1.return)) _a.call(linesOfText_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return tokens;
};
